export const getNextOrderNumber = (roles = []) => {
  const length = Array.isArray(roles) ? roles.length : 0;
  const nextOrder = length + 1 || 1;
  return String(nextOrder);
};

export const getNavItemIdsFromCheckedItems = (checkedItems = {}) => {
  return Object.keys(checkedItems)
    .filter((key) => checkedItems[key])
    .map((id) => parseInt(id, 10));
};

export const buildRolePayload = ({
  roleName,
  permissionType,
  orderNumber,
  isTwoFactorEnabled,
  checkedItems
}) => {
  const navItemIds = getNavItemIdsFromCheckedItems(checkedItems);

  return {
    name: roleName.trim(),
    fullAccess: permissionType,
    orderNumber,
    isTwoFactorEnabled,
    navItemIds
  };
};
